// Navigator right-panel router. Renders one of five variants based on the
// current selection (URL search params, resolved upstream in Navigator.tsx):
//   nothing → Dashboard · project → Project · model row → ModelSolution ·
//   any paper → Paper.

import type { Project } from "../../api/types";
import { DashboardPanel } from "./DashboardPanel";
import { ExamPanel } from "./ExamPanel";
import { ModelSolutionPanel } from "./ModelSolutionPanel";
import { PaperPanel } from "./PaperPanel";
import { ProjectPanel } from "./ProjectPanel";

import "./details.css";

// Sentinel paper ids for the virtual rows in the sidebar.
export const MODEL_PAPER_ID = "model";
export const EXAM_PAPER_ID = "exam";

interface Props {
  projects: Project[];
  selectedProjectId: string | null;
  selectedPaperId: string | null;
}

export function DetailsPanel({ projects, selectedProjectId, selectedPaperId }: Props) {
  const project = selectedProjectId
    ? projects.find((p) => String(p.id) === selectedProjectId)
    : undefined;

  if (!project) return <DashboardPanel projects={projects} />;

  if (selectedPaperId === EXAM_PAPER_ID) {
    return <ExamPanel project={project} />;
  }

  if (selectedPaperId === MODEL_PAPER_ID) {
    return <ModelSolutionPanel project={project} />;
  }

  if (selectedPaperId) {
    const paper = project.papers.find((p) => String(p.id) === selectedPaperId);
    if (paper) return <PaperPanel key={paper.id} project={project} paper={paper} />;
  }

  return <ProjectPanel project={project} />;
}
